import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

interface ItemType {
    img: string;
    title: string;
    desc: string;
}
export default function H() {
    const { t } = useLang('bkw');
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738836418693/7_1.png',
            title: t('H_item1_title'),
            desc: t('H_item1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738836418510/7_2.png',
            title: t('H_item2_title'),
            desc: t('H_item2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738836441976/7_3.jpg',
            title: t('H_item3_title'),
            desc: t('H_item3_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738836419094/7_4.jpg',
            title: t('H_item4_title'),
            desc: t('H_item4_desc'),
        },
    ];

    return (
        <div id="bkw-H" className={`bkw-H bkw-box ${css['bkw-H']}`}>
            <EfSpec />
            <div className="info">
                <h3 className="title title-s">{t('H_title')}</h3>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className="item" key={k}>
                        <div className="item-img">
                            <EfImg pc={item.img} />
                            {[0, 1].includes(k) && (
                                <svg className="arrow-y" xmlns="http://www.w3.org/2000/svg" width="95" height="21" viewBox="0 0 95 21" fill="none">
                                    <path d="M85.5357 10.084L1.9707 10.084" stroke="#F7A40A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M94.7289 10.0786L83.2129 0.0839844V20.084L94.7289 10.0786Z" fill="#F7A40A" />
                                </svg>
                            )}
                            {k === 2 && (
                                <svg className="arrow-g" xmlns="http://www.w3.org/2000/svg" width="88" height="8" viewBox="0 0 88 8" fill="none">
                                    <path d="M85.586 4.08399L2.021 4.08398" stroke="#707070" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M87.0068 3.58398C87.0068 5.26001 85.7068 6.58398 84.145 6.58398C82.5833 6.58398 81.2832 5.26001 81.2832 3.58398C81.2832 1.90796 82.5833 0.583984 84.145 0.583984C85.7068 0.583984 87.0068 1.90796 87.0068 3.58398Z"
                                        fill="#707070"
                                        stroke="#707070"
                                    />
                                </svg>
                            )}
                        </div>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
